import { SchedulePayload } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { fetchAllKandidatKey } from "../../queries/Kandidat/useFetchAllKandidat";
import getQueryClient from "../../queryClient";

export async function addSchedule(data: SchedulePayload) {
  const res = await ApiClient.put(`/AddSchedule`, data);
  return res.data;
}

export const useAddSchedule = mutationWrapper(addSchedule, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAllKandidatKey);
  },
});
